<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">
                {{ $t('setupBanner.pageTitle') }}
            </h1>
            <ts-breadcrumb :items="[
                {   text : $t('home'),href: '/'},
                {
                    text : $t('setupBanner.pageTitle'),
                    active : true
                }
            ]"/>
        </div>
   <ts-card>
      <div class="overflow-auto">
        <ts-table :records="resources">
          <template v-slot:thead>
            <thead>
              <tr>
                <th style="width: 30px">{{ $t('setupBanner.image') }}</th>
                <th width="10%">{{ $t('setupBanner.title') }}</th>
                <!-- <th class="text-center">
                  {{ $t('setupBanner.active') }}
                </th>
                <th class="text-center">
                  {{ $t('setupBanner.desktop') }}
                </th>
                <th class="text-center">
                  {{ $t('setupBanner.device') }}
                </th>
                <th width="10%">
                  {{ $t('setupBanner.second') }}
                </th> -->
                <th width="10%">
                  {{ $t('setupBanner.numberImage') }}
                </th>
                <th>
                  {{ $t('setupBanner.description') }}
                </th>
                <!-- <th>{{ $t('setupBanner.startDate') }}</th>
                <th>{{ $t('setupBanner.endDate') }}</th> -->
                <th style="width: 1px" class="text-center">
                  <a href="#" class="btn btn-xs btn-info" @click.prevent="addNewRow">
                    <i class="fa fa-plus"></i>
                  </a>
                </th>
              </tr>
              <TableProgressBar v-show="loading" :columnLength="9" />
            </thead>
          </template>
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              <ts-image-input :file="record.image_path ? record.image_path : file" @input="file => (record.image = file)"
                :width="105" :height="59" crop></ts-image-input>
            </td>
            <td class="ts-whitespace-no-wrap">
              <input type="text" class="form-control" style="width: 300px;" v-model="record.title">
            </td>
            <!-- <td class="text-center">
              <a-switch size="small" :checked="record.is_active" @change="isActiveCloseOpen(record)" />
            </td>
            <td class="text-center">
              <a-switch size="small" :checked="record.is_desktop" @change="isDefaultCloseOpen(record)" />
            </td>
            <td class="text-center">
              <a-switch size="small" :checked="record.is_device_display" @change="isDeviceCloseOpen(record)" />
            </td> -->
            <!-- <td class="ts-whitespace-no-wrap">
              <input type="number" class="form-control" v-model.number="record.interval_second" />
            </td> -->
            <td class="ts-whitespace-no-wrap">
              <input type="number" class="form-control" v-model.number="record.display_order" />
            </td>
            <td class="ts-whitespace-no-wrap">
              <textarea type="text" class="form-control" v-model="record.description" />
            </td>
            <!-- <td class="ts-whitespace-no-wrap">
              <DatePicker  type="date"
                :value="record.start_date"
                style="width:100%"
                placeholder="DD-MM-YYYY"
                format="dd-MM-yyyy"
                @on-change="(date) => record.start_date = date"
            ></DatePicker>
            </td>
            <td class="ts-whitespace-no-wrap">
              <DatePicker type="date"
                :value="record.end_date"
                style="width:100%"
                placeholder="DD-MM-YYYY"
                format="dd-MM-yyyy"
                @on-change="(date) => record.end_date = date">
              </DatePicker>
            </td> -->
            <td class="ts-whitespace-no-wrap text-center">
              <ts-button color="primary" class="btn-xs mr-2" @click="save(record)" :disabled="record._saving || record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._saving" ></i>
                <i class="fa fa-save" v-else></i>
              </ts-button>
              <ts-button color="danger" class="btn-xs" @click.prevent="removeRow(record)" :disabled="record._deleting || record._saving">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash" v-else></i>
              </ts-button>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'
import Compressor from 'compressorjs'
export default {
  name: 'setupBanner',
  components: {
    TableProgressBar
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      file: require('../../../assets/cover-default-image.png'),
      newRow: {
        id: 0,
        interval_second: 3,
        start_date: null,
        title: null,
        description : null,
        end_date: null,
        display_order: null,
        is_desktop: true,
        is_device_display: true,
        is_active: true,
        image_path: null,
        _saving: false,
        _deleting: false,
      }
    }
  },
    created() {
    this.fetchData()
  },
  computed:{
    ...mapState('website/setupBanner',['resources','pagination']),
  },
  methods:{
    isActiveCloseOpen(record) {
      record.is_active = record.is_active ? false : true
    },
    isDefaultCloseOpen(record) {
      record.is_desktop = record.is_desktop ? false : true
    },
    isDeviceCloseOpen(record) {
      record.is_device_display = record.is_device_display ? false : true
    },

   addNewRow() {
    //Add new row with display_order auto increase by 1 
    this.resources.push({..._.clone(this.newRow),
        display_order: Math.max(...this.resources.map(record => record.display_order || 0)) + 1
    });
    },
    removeRow(record){
      record._deleting = true
      if (record.id > 0){
        this.$store
        .dispatch('website/setupBanner/destroy', record.id)
        .then(response =>{
          record._deleting = false
          this.resources.splice(this.resources.indexOf(record), 1)
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          record._deleting = false
        })
      } else{
        this.resources.splice(this.resources.indexOf(record),1)
      }
    },
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('website/setupBanner/fetch')
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    save(record) {
      let formData = new FormData()
      if (record.id > 0) {
        formData.append('_method', 'PUT')
      }
      formData.append('is_desktop',record.is_desktop)
      formData.append('is_device_display',record.is_device_display)
      formData.append('is_active', record.is_active)
      formData.append('interval',(record.interval_second ? record.interval_second : 3) * 1000)
      formData.append('display_order', record.display_order)
      formData.append('start_date', record.start_date)
      formData.append('end_date', record.end_date)
      formData.append('description', record.description)
      formData.append('title', record.title)

      if (!record.image && !record.image_path) {
        this.$toasted.error(`Image is required - Please upload an image.`);
        return; 
      }
      if (!record.title) {
        this.$toasted.error(`Title is required - Please input title.`);
        return; 
      }
      if (record.image instanceof File || record.image instanceof Blob) {
        new Compressor(record.image, {
          quality: 0.5,
          success: async result => {
            formData.append('image', result)
            record._saving = true
            this.$store
              .dispatch('website/setupBanner/store', {
                id: record.id,
                data: formData
              })
              .then(response => {
                record._saving = false
                this.$toasted.success(response.message)
                this.fetchData()
              })
              .catch(error => {
                record._saving = false
                this.$toasted.error(error.message)
              })
          }
        })
      }
      //Check if image not being update keep the existing one
      if(record.image_path){
        record._saving = true
            this.$store
              .dispatch('website/setupBanner/store', {
                id: record.id,
                data: formData
              })
              .then(response => {
                record._saving = false
                this.$toasted.success(response.message)
                this.fetchData()
              })
              .catch(error => {
                record._saving = false
                this.errors = new Errors(error.errors)
              })
      }
    },
  },
}
</script>
<style lang="css" scoped>
table td {
  vertical-align: middle;
}
</style>

